import Rails from '@rails/ujs'
import _ from "lodash";
import 'select2/dist/js/select2.full';
import bootbox from 'bootbox';
import DetailsAction from './details_action'
import axios from 'axios'

export default class SidebarDetails {
  constructor(base_url) {
    this.base_url = base_url
  }

  call() {
    this.getData()
  }

  showLessContent() {
    const content = document.getElementById("content");
    const text = document.getElementById("text");
    const expandLink = document.getElementById("expand-link");

    expandLink.addEventListener("click", (event) => {
      if (expandLink.textContent === "See More") {
        expandLink.textContent = "See Less";
        text.classList.remove("long-text");
      } else {
        expandLink.textContent = "See More";
        text.classList.add("long-text");
      }
    });

    // How to detect if text is overflowing / ellipsis are active?
    // We leverage two properties scrollWidth & offsetHeight

    // scrollWidth - a property in JavaScript that represents the total height of the element's content,
    // including the content that is not visible within the element's viewport due to overflow.

    // scrollHeight - is a property in JavaScript that represents the total height of the element, including its visible content, padding, and borders.
    // It does not include margins or hidden content that is not visible within the element's container.

    // requestAnimationFrame(() => {
    if (text.scrollHeight > content?.offsetHeight) {
      expandLink.style.display = "block";
    } else {
      expandLink.style.display = "none";
    }
    // });
  }

  getData() {
    let url = this.base_url + '/show_data?data_type=sidebar_details'

    Rails.ajax({
      type: "GET",
      url: url,
      success: this.successResponse.bind(this)
    })
  }

  getDataAction() {
    let url = this.base_url + '/action_button';
    Rails.ajax({
      type: "GET",
      url: url,
      success: (response) => {
        if (response.html) {
          this.wrapperButtonDetails.innerHTML = response.html
          new DetailsAction(response.action_type)
        }
      }
    })
  }

  successResponse(response) {
    this.data = response
    this.getDataAction()
    this.wrapperSidebarDetails.innerHTML = this.parseTemplate()
    this.showLessContent()
  }

  parseTemplate () {
    _.templateSettings = {
      evaluate:    /\{\{(.+?)\}\}/g,
      interpolate: /\{\{=(.+?)\}\}/g,
      escape:      /\{\{-(.+?)\}\}/g
    }

    let compiled = _.template(this.templateSidebarDetails.innerHTML)

    return compiled(this.data)
  }

  get wrapperSidebarDetails() {
    return document.getElementById('wrapper-sidebar-details')
  }

  get templateSidebarDetails() {
    return document.getElementById('template-sidebar-details')
  }

  get wrapperButtonDetails() {
    return document.getElementById('wrapper-button-details')
  }
}